// Standard library imports
import React, { useEffect, useState } from 'react';
import Typography from '../../../../components/Typography/Typography';
// External library imports
import { get as lodashGet, set as lodashSet, mean as lodashMean } from 'lodash';

import { Form, Formik } from 'formik';
// Css imports
import bidClasses from '../Bidding.module.css';
import { Input } from '../../../../components/Inputs/Input';
import { momentTimeFormater } from '../../../../utils/dateHelper';
import { updateRegulationPrice } from '../../../../validations/Root/biddingValidator';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import Dropdown from '../../../../components/Inputs/Dropdown';
import { Capitalize } from '../../../../utils/stringHelper';

const ENERGY_BID_TYPE = [
    {
        label: 'Direct',
        value: 'direct',
    },
    {
        label: 'Schedule',
        value: 'schedule',
    },
];

export const UpdateAfrrEnergyBidHour = ({ bid, energyBidsToPost, setEnergyBidsToPost, closeModal, market, setBidsData, setEnergyBidType }) => {
    const [winningHour, setWinningHour] = useState([]);

    const [initialValues, setInitialValues] = useState({
        regulationPrice: lodashGet(energyBidsToPost, [bid._id, 'regulationPrice'], []),
    });

    useEffect(() => {
        if (bid) {
            if (lodashGet(bid, ['primary', 'provider', 'bidStatus'], []).length) {
                const temp = [];
                lodashGet(bid, ['primary', 'provider', 'bidStatus'], []).map((el) => {
                    if (el.price > 0) temp.push(el.hour);
                });
                setWinningHour(temp);
            }
        }
    }, [bid]);

    const handleSubmit = (value) => {
        setEnergyBidsToPost((prev) => ({
            ...prev,
            [bid._id]: {
                ...lodashGet(prev, [bid._id]),
                regulationPrice: value.regulationPrice,
            },
        }));

        if (market === 'mFRR-energy') {
            const type = bid?.bidType === 'normal' ? 'normalBids' : 'bundleBids';
            setBidsData((prev) => {
                lodashGet(prev, [type]).map((el) => {
                    if (el._id === bid._id) el.energyBidType = Capitalize(value?.energyBidType || '');
                });
                return prev;
            });
            setEnergyBidType((prev) => ({ ...prev, [bid._id]: value?.energyBidType }));
        }

        closeModal();
    };

    return (
        <div>
            <div className={bidClasses.FormWrapper}>
                <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={updateRegulationPrice}>
                    {({ errors, values }) => (
                        <Form>
                            <div>
                                <div className={allDeviceClasses.InputContainer} style={{ marginBottom: '2vh' }}>
                                    <div className={allDeviceClasses.FieldControl}>
                                        <label>
                                            Energy Bid Type <span className="required">*</span>
                                        </label>
                                        <Dropdown name={'energyBidType'} options={ENERGY_BID_TYPE} defaultValue={ENERGY_BID_TYPE[0]} />
                                    </div>
                                </div>
                                <Typography content={'Regulation Price (€)'} size={14} />
                                <div className={bidClasses.EditContainer}>
                                    {values?.regulationPrice?.map((__, index) => (
                                        <div className={allDeviceClasses.InputContainer} key={index}>
                                            <div className={allDeviceClasses.FieldControl}>
                                                <label>
                                                    Slot {index + 1} / Hour {momentTimeFormater(bid.date).add(index, 'hour').hour()}-
                                                    {momentTimeFormater(bid.date)
                                                        .add(index + 1, 'hour')
                                                        .hour()}{' '}
                                                    Price
                                                </label>
                                                <Input
                                                    name={`regulationPrice[${index}]`}
                                                    id={index}
                                                    type="number"
                                                    disabled={winningHour.includes(index) ? true : false}
                                                    style={{ marginTop: '0' }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className={allDeviceClasses.ButtonContainer}>
                                <div>
                                    <button type="button" className="btn-secondary" onClick={closeModal}>
                                        Cancel
                                    </button>
                                </div>
                                <div>
                                    <button type="submit" className="btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
